import React, { useContext, useEffect } from "react"
import AppContext from "../../shared/AppContext"
import { Redirect } from "react-router"
import SearchBar from "../../components/SearchBar"
import gql from "graphql-tag"
import { Query } from "react-apollo"
import { Link } from "react-router-dom"
import useDebounce from "../../hooks/useDebounce"
import UpsellModal from "../../components/UpsellModal"
import { Waypoint } from "react-waypoint"

import "./search.scss"

const SEARCH_MARKET_ARRAY_REPORTS = gql`
  query SearchMarketArrayReports($searchKeyword: String, $offset: Int!) {
    searchInteractiveReports(searchKeyword: $searchKeyword, offset: $offset) {
      id
      name
      slug
      description
    }
  }
`

const MarketArraySearch = (props) => {
  const { isUserAuthenticated, roles } = props.viewer
  const { trackEvent } = useContext(AppContext)

  const hasMarketArrayRole = roles
    ? roles.includes("MarketArrayReports")
    : false

  if (!isUserAuthenticated) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: "/market-array" } }} />
    )
  }

  if (!hasMarketArrayRole) {
    return <UpsellModal />
  }

  const {
    value: searchKeyword,
    deferredValue: deferredKeyword,
    setValue: setSearchKeyword,
  } = useDebounce(250)

  const trackSearchKeyword = () => {
    trackEvent("Market Array Search", {
      keywordSearch: deferredKeyword,
    })
  }

  useEffect(trackSearchKeyword, [deferredKeyword])

  const onLoadMoreMarketArray = (data, fetchMore) => {
    const currentLength = data.searchInteractiveReports.length

    fetchMore({
      variables: {
        offset: currentLength,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        return Object.assign({}, prev, {
          searchInteractiveReports: [
            ...prev.searchInteractiveReports,
            ...fetchMoreResult.searchInteractiveReports,
          ],
        })
      },
    })
  }

  const globalWindow = typeof window !== "undefined" ? window : undefined

  return (
    <div className="market-array-container">
      <SearchBar
        classes={["border", "rounded"]}
        placeholder={"Search market array reports"}
        value={searchKeyword}
        onChange={(e) => {
          setSearchKeyword(e.target.value)
        }}
      />
      <div className="list-container">
        <Query
          query={SEARCH_MARKET_ARRAY_REPORTS}
          fetchPolicy="network-only"
          variables={{
            dataset: "MarketArrayReports",
            searchKeyword: deferredKeyword,
            offset: 0,
          }}
        >
          {({ data, error, loading, fetchMore }) => {
            if (loading) {
              return <div>Loading...</div>
            }

            if (error) {
              return <div>An error occurred while getting reports.</div>
            }

            if (data && data.searchInteractiveReports) {
              return data.searchInteractiveReports.map((report, i) => {
                return data.searchInteractiveReports.length ? (
                  <React.Fragment key={i}>
                    <Link
                      key={i}
                      to={`/market-array/${report.slug}`}
                      className={"market-array-result-card"}
                      data-cy={"market-array-result-card"}
                    >
                      <h3 className={report.description ? "mb" : ""}>
                        {report.name}
                      </h3>
                      {report.description ? (
                        <div className="market-array-description">
                          {report.description}
                        </div>
                      ) : null}
                    </Link>

                    {i === data.searchInteractiveReports.length - 5 && (
                      <Waypoint
                        scrollableAncestor={globalWindow}
                        onEnter={() => onLoadMoreMarketArray(data, fetchMore)}
                      />
                    )}
                  </React.Fragment>
                ) : (
                  <div>No market array reports found.</div>
                )
              })
            }

            return null
          }}
        </Query>
      </div>
    </div>
  )
}

export default MarketArraySearch
